<span *ngIf="total; else emptyTotal">{{ total }} items</span>
<ng-template #emptyTotal><span>&nbsp;</span></ng-template>
